import React from 'react'
import './WhyRiftChess.css'

const WhyRiftChess = ({ onNavigateToDashboard, onNavigateToRules }) => {
  return (
    <div className="why-riftchess">
      <div className="why-riftchess-hero">
        <div className="why-riftchess-hero-content">
          <h1>What is RiftChess?</h1>
          <p>
            Experience chess like never before with dynamic gameplay that evolves every move
          </p>
        </div>
        <div className="why-riftchess-hero-visual">
          <div className="animated-board">
            <div className="board-square light"></div>
            <div className="board-square dark"></div>
            <div className="board-square light special-red"></div>
            <div className="board-square dark"></div>
            <div className="board-square dark"></div>
            <div className="board-square light special-blue"></div>
            <div className="board-square dark"></div>
            <div className="board-square light"></div>
            <div className="board-square light"></div>
            <div className="board-square dark"></div>
            <div className="board-square light special-green"></div>
            <div className="board-square dark"></div>
            <div className="board-square dark special-red"></div>
            <div className="board-square light"></div>
            <div className="board-square dark"></div>
            <div className="board-square light"></div>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="container">
          <h2 className="section-title">Revolutionary Chess Experience</h2>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon death-icon"></div>
              <h3>Death Squares</h3>
              <p>
                Red death squares add unprecedented tension to every game. Any piece that ends its turn on a death square is eliminated, forcing players to think strategically about piece placement and timing.
              </p>
              <div className="feature-detail">
                <span className="detail-label">Spawns every:</span>
                <span className="detail-value">3 moves</span>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-icon teleport-icon"></div>
              <h3>Teleportation</h3>
              <p>
                Blue teleport squares allow pieces to traverse the entire board instantly. Land on one, and choose any empty square as your destination - opening up impossible tactical combinations.
              </p>
              <div className="feature-detail">
                <span className="detail-label">Spawns every:</span>
                <span className="detail-value">7 moves</span>
              </div>
            </div>

            <div className="feature-card">
              <div className="feature-icon promotion-icon"></div>
              <h3>Dynamic Promotion</h3>
              <p>
                Green promotion squares transform pieces mid-game. Upgrade bishops and knights to rooks, or rooks to queens. Even pawns can promote to bishops or knights before reaching the end.
              </p>
              <div className="feature-detail">
                <span className="detail-label">Spawns every:</span>
                <span className="detail-value">10 moves</span>
              </div>
            </div>
          </div>

          <div className="rules-cta">
            <button
              className="rules-button"
              onClick={() => onNavigateToRules && onNavigateToRules()}
            >
              See Complete Rules
            </button>
          </div>
        </div>
      </div>

      <div className="comparison-section">
        <div className="container">
          <h2 className="section-title">Traditional Chess vs RiftChess</h2>

          <div className="comparison-grid">
            <div className="comparison-card traditional">
              <h3>Traditional Chess</h3>
              <ul>
                <li>Static board with unchanging squares</li>
                <li>Predictable piece movements</li>
                <li>Games can become repetitive</li>
                <li>Limited tactical surprises</li>
                <li>Same strategies work repeatedly</li>
                <li>Memory and opening sequences favor experienced players</li>
              </ul>
            </div>

            <div className="vs-divider">
              <span>VS</span>
            </div>

            <div className="comparison-card riftchess">
              <h3>RiftChess</h3>
              <ul>
                <li>Dynamic board with evolving special squares</li>
                <li>Pieces can teleport and transform</li>
                <li>Every game offers unique challenges</li>
                <li>Constant tactical surprises</li>
                <li>Requires adaptive thinking</li>
                <li>Intuition and creativity matter more than memorization</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="gameplay-section">
        <div className="container">
          <h2 className="section-title">Adaptive Gameplay</h2>

          <div className="gameplay-content">
            <div className="gameplay-text">
              <h3>Think Beyond the Board</h3>
              <p>
                RiftChess challenges you to think several moves ahead while adapting to an ever-changing battlefield. Special squares appear based on move count, creating a rhythm that skilled players can anticipate and exploit.
              </p>

              <h3>Master New Strategies</h3>
              <p>
                Traditional opening theories still matter, but RiftChess rewards players who can quickly adapt their strategy as the board transforms. Will you play defensively to avoid death squares, or aggressively to control teleportation points?
              </p>

              <h3>Every Game is Unique</h3>
              <p>
                With special squares spawning based on game state rather than randomness, no two games play exactly the same way. The same opening can lead to completely different middlegame scenarios.
              </p>
            </div>

            <div className="gameplay-stats">
              <div className="why-stat-item">
                <div className="stat-number">3</div>
                <div className="stat-label">Special Square Types</div>
              </div>
              <div className="why-stat-item">
                <div className="stat-number">∞</div>
                <div className="stat-label">Unique Game States</div>
              </div>
              <div className="why-stat-item">
                <div className="stat-number">10x</div>
                <div className="stat-label">More Tactical Depth</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Experience the Evolution of Chess?</h2>
            <p>
              Join thousands of players who have discovered the thrill of RiftChess.
              Every move matters, every square can change the game.
            </p>
            <button
              className="cta-button"
              onClick={() => onNavigateToDashboard && onNavigateToDashboard()}
            >
              Play RiftChess Now
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhyRiftChess